import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { BarChart } from '@mui/x-charts/BarChart';


export class BarChartCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      context: this.props.context ? this.props.context : 'paciente',
      dataini: this.props.dataini ? this.props.dataini : new Date().toISOString().substring(0, 10),
      datafim: this.props.datafim ? this.props.datafim : new Date().toISOString().substring(0, 10),
      sexo: this.props.sexo ? this.props.sexo : [1],
      idade: this.props.idade ? this.props.idade : [18,100],
      procedimento: this.props.procedimento ? this.props.procedimento : [1],
      doutor: this.props.doutor ? this.props.doutor : [1],
      title: '---',
      description: '---',
      dataset: [],
    };
  }
  
  
  componentDidMount = () => {
    this.updateData();
  }; 
  
  
  
  updateStates = (dataini, datafim, sexo, idade, procedimento, doutor) => {
    this.setState({ dataini: dataini, datafim: datafim, sexo: sexo, idade: idade, procedimento: procedimento, doutor: doutor }, () => {this.updateData()} );
  }
  
  
  
  
  updateData = () => {
    if(this.state.context === 'idade'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/AgeChart/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: 'Idade',
            description: "Idade x Número de Sessões",
            dataset: retValues[0],
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    } 
    
    if(this.state.context === 'estadocivil'){
      this.setState({ loading: true });
      this.props.api
        .get('/Dashboard/MaritalStatusChart/' + this.state.dataini + '/' + this.state.datafim + '/' + this.state.sexo + '/' + this.state.idade + '/' + this.state.procedimento + '/' + this.state.doutor )
        .then((r) => {
          var retValues = this.parseStats(r);
          
          this.setState({
            title: 'Estado Civil',
            description: "Estado Civil x Número de Sessões",
            dataset: retValues[0],
            loading: false,
          });             
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    } 
    
    
      
  }; 
  
  
  
  parseStats(r){
    //console.log(r.data);               
    return([r.data]);
  }
  
  

    
  
  
  
  render() {
    const colorPalette = ['#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff','#0059b3', '#027af2', '#99ccff'];
  
    return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>{this.state.title}</Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>{this.state.description}</Typography>

        {this.state.dataset.length>0 &&
        <BarChart
          borderRadius={8}
          colors={colorPalette}
          dataset={this.state.dataset}
          xAxis={[{  scaleType: 'band', dataKey: 'xvalue' }]}   
          series={[{ dataKey: 'yvalue' }]}
          height={250}
          margin={{ left: 50, right: 0, top: 20, bottom: 20 }}
          grid={{ horizontal: true }}
          slotProps={{
            legend: {
              hidden: true,
            },
          }}
        /> 
        }
      </CardContent>
    </Card>
    
    
    );
  }
}























